var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-6 p-1 offset-6" }, [
      _c(
        "button",
        {
          class: ["btn", _vm.bitSet ? "btn-primary" : "btn-secondary"],
          attrs: { disabled: _vm.bitSet },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.sendClearance(_vm.silo.siloNumber)
            }
          }
        },
        [
          _vm.loading
            ? _c("em", { staticClass: "fas fa-spinner fa-spin" })
            : _vm.success === true
            ? _c("em", { staticClass: "fas fa-check bounce" })
            : _vm.success === false
            ? _c("em", { staticClass: "fas fa-times bounce" })
            : _c("span", [_vm._v(_vm._s(_vm.label))])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }